import React from 'react';
import PropTypes from 'prop-types';

const logoStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/images/deshaw-logo.png)`,
    backgroundRepeat: 'no-repeat',
};

class Topbar extends React.Component {
    render() {
        return (
            <>
                <div className="w-full bg-gray-200 pt-4">
                    <div className="md:flex md:justify-item-center w-full bg-blue-600 max-w-6xl px-4 lg:px-0 mx-auto text-white  py-4">
                        <div
                            className="md:w-1/4 h-16 md:bg-center mx-2 lg:mx-auto"
                            style={logoStyle}
                        />
                        <div className="md:w-3/4 border-l border-white px-4 py-1">
                            <div>
                                {' '}
                                THE D. E. SHAW GROUP INDUSTRY CONSULTING PROGRAM
                                (ICP)
                            </div>
                            <div className="text-2xl  font-semibold">
                                {' '}
                                {this.props.title}{' '}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

Topbar.propTypes = {
    res: PropTypes.any,
    err: PropTypes.any,
    title: PropTypes.string,
};

export default Topbar;
